import React from 'react'
import { HashRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@mui/material/TextField';
import MyHeader from './header'
import MyFooter from '../UI/Footer/Footer'
import DrawerResumenPedido from '../DrawerResumenPedido'
import DrawerNotificaciones from '../DrawerNotificaciones'
import CalendarioContainer from '../../containers/CalendarioContainer'
import FeedbackButton from "@smiledev/react-web-feedback"
import CustomModal from '../UI/Modals/CustomModal'
import CustomInput from "../Common/textInput/CustomInput";
import OfertasContainer from '../../containers/OfertasContainer'
import { postBotonArrepentimiento } from "../../sagas/CatalogoSaga/calls";
import { Route } from 'react-router-dom'
import './layout.css'
import * as Notification from '../Common/notification';
import { routes } from '../../config/routes'
import { getConfigFeedback } from "../../sagas/ConfigGlobalSaga/calls";
import { connect } from 'react-redux';
import { sagaFetchInstalacionTexto } from '../../reducers/SessionReducer/actions';
import { instalacionTextoSelector } from '../../selectors/sessionSelector';


const drawerWidth = 350;

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    opacity: 1
  },
  drawerPaper: {
    width: drawerWidth,
    background: '#EFF0F8 0% 0% no-repeat padding-box',
    opacity: 1,
    zIndex: 1500
  },
  content: {
    flexGrow: 1,
    padding: '0px',
    marginTop: '30px',
    flexGrow: 1,
    width: "100%",
  },
  rootWhatsapp: {
    flexGrow: 1,
  },
  show: {
    transform: 'translateY(0)',
    transition: 'transform .5s',
  },
  hide: {
    transform: 'translateY(+135%)',
    transition: 'transform .5s',
  },
  rootDialog: {
    zIndex: 1550,
  },
  rootContent: {
    borderRadius: '21px',
    minWidth: '300px'
  }
});

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
      openFormularioArrepentimiento: false,
      arrepentimientoData: {
        nombre: '',
        dni: '',
        telefono: '',
        email: '',
        descripcion: ''
      },
      isSubmitting: false,
      arrepentimientoMessage: {
        error: false,
        mess: ''
      }
    };
    this.scrollPosition = 0;
  }

  async componentDidMount() {
    if (typeof getConfigFeedback === 'function') {
      try {
        const token = await getConfigFeedback();
        this.setState({ token });
      } catch (error) {
        console.error('Error fetching token:', error);
      }
    }

    const { fetchInstalacionTexto, instalacion } = this.props;
    if (instalacion && instalacion.id) {
      await fetchInstalacionTexto(instalacion.id);
    } else {
      console.error("Instalacion es undefined o no tiene un ID");
    }
  }

  conseguirTextoGenerico = (instalacionTexto, nombre) => {
    const texto = instalacionTexto.find(item => item.nombre === nombre);
    return texto ? texto.valor : '';
  }

  handleChangeForm = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    let form = this.state.arrepentimientoData;
    form[name] = value;

    this.setState({ arrepentimientoData: form });
  };

  submitBotonArrepentimientoForm = () => {
    if (
      !this.state.arrepentimientoData.nombre ||
      !this.state.arrepentimientoData.email ||
      !this.state.arrepentimientoData.descripcion ||
      !this.state.arrepentimientoData.dni ||
      !this.state.arrepentimientoData.telefono
    ) {
      this.setState({
        arrepentimientoMessage: {
          error: true,
          mess: "Complete todos los campos.",
        },
      });
      return;
    }

    this.setState({ isSubmitting: true });

    this.setState({ openFormularioArrepentimiento: false });

    postBotonArrepentimiento(this.state.arrepentimientoData)
      .then((response) => {
        if (response.status > 200) {
          Notification.showError("Ups, algo salió mal.");
        } else {
          Notification.showSuccess("Enviado correctamente.");
        }
      })
      .catch((err) => {
        Notification.showError("Ups, algo salió mal.");
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  };

  handleOpenArrepentimientoModal = () => {
    this.setState({ openFormularioArrepentimiento: true });
    // Inhabilitar el botón y luego habilitarlo después de 5 segundos
    // asi evitamos que el usuario pueda pulsar varias veces el botón
    this.setState({ disableButton: true }, () => {
      setTimeout(() => {
        this.setState({ disableButton: false });
      }, 5000);
    });
  };

  saveScrollPosition = () => {
    // Guardo la posición del scroll
    const scrollContainer = document.querySelector('div[role="presentation"] #scrollItemsPedido');
    if (scrollContainer) {
      this.scrollPosition = scrollContainer.scrollTop;
    }
  }

  restoreScrollPosition = () => {
    // Restauro la posición del scroll
    const scrollContainer = document.querySelector('div[role="presentation"] #scrollItemsPedido');
    if (scrollContainer) {
      scrollContainer.scrollTop = this.scrollPosition;
    }
  }

  componentDidUpdate(prevProps) {
    // Si cambia el pedido, restauro la posición del scroll
    if (prevProps.pedido !== this.props.pedido) {
      this.restoreScrollPosition();
    }
  }


  render() {
    const { classes, instalacionTexto } = this.props;

    const { token } = this.state;

    if (this.props.instalacion === undefined)
      return null



    // calculo el alto del header para asignar el margen superior al contenido
    let headerHeight = 80
    if (this.props.header.show === false)
      headerHeight = 0

    let contenidoExtraHeader = document.getElementById('headerContenidoExtra')
    if (contenidoExtraHeader && this.props.header.extraContent !== undefined)
      headerHeight += contenidoExtraHeader.clientHeight


    // Textos genéricos
    const textoGenericoMembresia = this.conseguirTextoGenerico(instalacionTexto, 'TextoGenericoMembresia') || 'Membresía';


    return (
      <HashRouter>
        <div className={classes.root}>

          {/* HEADER */}
          {this.props.header.show &&
            <MyHeader
              showDrawer={this.props.header.showDrawer}
              showBackButton={this.props.header.showBackButton}
              handleOnBackClick={this.props.header.handleOnBackClick}
              drawerOpen={this.props.drawerOpen}
              handleDrawerOpen={this.props.handleDrawerOpen}
              handleDrawerClose={this.props.handleDrawerClose}
              instalacion={this.props.instalacion}
              contenidoExtra={this.props.header.extraContent}
              handleOnCerrarSesion={this.props.handleOnCerrarSesion}
              handleOnClickLogo={this.props.handleOnClickLogo}

              preguntasFrecuentes={this.props.preguntasFrecuentes}
              usuario={this.props.usuario}
              showResumenPedido={this.props.showResumenPedido}
              pedido={this.props.pedido}
              filterArticulos={this.props.filterArticulos}
              handleOnChangeFilter={this.props.handleOnChangeFilter}
              handleOnClearBusqueda={this.props.handleOnClearBusqueda}
              handleOnClickIniciarSesion={this.props.handleOnClickIniciarSesion}
              handleOnClickVerCarrito={this.props.handleOnClickVerCarrito}
              showBusqueda={this.props.showBusqueda}

              handleOnClickBasesCondiciones={this.props.handleOnClickBasesCondiciones}
              handleOnClickOpenModalRubros={this.props.handleOnClickOpenModalRubros}
              openModalRubros={this.props.openModalRubros}
              handleOnClickOpenCalendario={this.props.handleOnClickOpenCalendario}
              handleOnClickOpenNotidicaciones={this.props.handleOnClickOpenNotidicaciones}
              handleOnClickFavoritos={this.props.handleOnClickFavoritos}
            />
          }

          <main className={`${classes.content} backMain`} style={{ marginTop: `${headerHeight}px` }}>

            {/* div separador cuando se muestra el menú superior */}
            {this.props.showHeader &&
              <div className={classes.toolbar} />
            }

            {routes()}

            {this.props.instalacion && this.props.instalacion.listaOfertas && this.props.instalacion.listaOfertas.length > 0 &&
              this.props.instalacion.listaOfertas.map((o) => {
                return <Route
                  path={`/${o.tag}`}
                  render={(props) => (
                    <OfertasContainer oferta={o} />
                  )}
                />
              })}

            {/* FOOTER */}
            {this.props.footer.show &&
              <MyFooter
                instalacion={this.props.instalacion}
                existePedido={this.props.pedido !== undefined ? true : false}
                handleOnClickBasesCondiciones={this.props.handleOnClickBasesCondiciones}
                handleOpenArrepentimientoModal={this.handleOpenArrepentimientoModal}
                disableButton={this.state.disableButton}
              />}
            <CustomModal
              open={this.state && this.state.openFormularioArrepentimiento}
              onClose={() => {
                this.setState({
                  openFormularioArrepentimiento: false,
                  arrepentimientoMessage: {
                    error: false,
                    mess: "",
                  },
                  arrepentimientoData: {
                    nombre: "",
                    dni: "",
                    telefono: "",
                    email: "",
                    descripcion: ""
                  }
                });
              }}
              title="Botón de arrepentimiento"
              buttonNames={["CANCELAR", "ENVIAR"]}
              buttonActions={[
                () => {
                  this.setState({
                    openFormularioArrepentimiento: false,
                    arrepentimientoMessage: {
                      error: false,
                      mess: "",
                    },
                    arrepentimientoData: {
                      nombre: "",
                      dni: "",
                      telefono: "",
                      email: "",
                      descripcion: ""
                    }
                  });
                },
                () => {
                  if (!this.state.disableButton && !this.state.isSubmitting) {
                    this.setState({ disableButton: true }, () => {
                      this.submitBotonArrepentimientoForm();
                      this.setState({
                        arrepentimientoData: {
                          nombre: "",
                          dni: "",
                          telefono: "",
                          email: "",
                          descripcion: ""
                        }
                      });
                      setTimeout(() => {
                        this.setState({ disableButton: false });
                      }, 5000);
                    });
                  }
                },
              ]}
              isSubmitting={this.state.isSubmitting}
            >
              <div className="formularioArrepentimientoContainer">
                <div className="inputContainer">
                  <span class="label">Nombre completo</span>
                  <br />
                  <CustomInput
                    placeholder="Nombre completo"
                    value={this.state.arrepentimientoData.nombre}
                    name="nombre"
                    onChange={this.handleChangeForm}
                    error={undefined}
                  />
                </div>
                <div className="inputContainer">
                  <span class="label">DNI</span>
                  <br />
                  <CustomInput
                    placeholder="DNI"
                    value={this.state.arrepentimientoData.dni}
                    name="dni"
                    type='number'
                    onChange={this.handleChangeForm}
                    onKeyPress={(event) => {
                      if (event.target.value.length === 9) event.preventDefault();
                    }}
                    error={undefined}
                  />
                </div>
                <div className="inputContainer">
                  <span class="label">Teléfono</span>
                  <br />
                  <CustomInput
                    placeholder="Teléfono"
                    type='number'
                    value={this.state.arrepentimientoData.telefono}
                    name="telefono"
                    onChange={this.handleChangeForm}
                    onKeyPress={(event) => {
                      if (event.target.value.length === 15) event.preventDefault();
                    }}
                    error={undefined}
                  />

                </div>
                <div className="inputContainer">
                  <span class="label">Email</span>
                  <br />
                  <CustomInput
                    placeholder="Email"
                    value={this.state.arrepentimientoData.email}
                    name="email"
                    onChange={this.handleChangeForm}
                    error={undefined}
                  />
                </div>
                <div className="inputContainer">
                  <span class="label">Motivo de arrepentimiento</span>
                  <br />
                  <TextField
                    placeholder="Motivo de arrepentimiento"
                    multiline
                    rows={4}
                    value={this.state.arrepentimientoData.descripcion}
                    name="descripcion"
                    onChange={this.handleChangeForm}
                    error={undefined}
                    sx={{ width: '100%' }}
                  />
                </div>
                {this.state.arrepentimientoMessage.mess && (
                  <span
                    class={
                      this.state.arrepentimientoMessage.error
                        ? "label-error"
                        : "label-success"
                    }
                  >
                    {this.state.arrepentimientoMessage.mess}
                  </span>
                )}
              </div>
            </CustomModal>
          </main>

          {/* DRAWER PARA CELULARES Y TABLET (EXPANDIBLE) */}
          {this.props.pedido !== undefined && this.props.showResumenPedido === true &&
            <DrawerResumenPedido
              usuario={this.props.usuario}
              instalacion={{...this.props.instalacion}}
              pedido={this.props.pedido}
              handleOnClickCheckout={this.props.handleOnClickCheckout}
              open={this.props.openResumenPedido}
              handleOnClose={this.props.handleOnClickVerCarrito}
              handleAgregarQuitarUnidad={(...args) => {
                this.saveScrollPosition();
                this.props.handleAgregarQuitarUnidad(...args);
              }}
              loading={this.props.loading.show}
              handleOnVaciarCartito={this.props.handleOnVaciarCartito}
              textoGenericoMembresia={textoGenericoMembresia}
            />}

          {/* DRAWER FIJO PARA RESOLICIONES MAYORES A 768 */}
          {!this.props.openNotificaciones && this.props.pedido !== undefined && this.props.showResumenPedido === true && !this.props.openCalendario &&
            <DrawerResumenPedido
              usuario={this.props.usuario}
              instalacion={{...this.props.instalacion}}
              pedido={this.props.pedido}
              handleOnClickCheckout={this.props.handleOnClickCheckout}
              isPersistent
              handleAgregarQuitarUnidad={(...args) => {
                this.saveScrollPosition();
                this.props.handleAgregarQuitarUnidad(...args);
              }}
              loading={this.props.loading.show}
              handleOnVaciarCartito={this.props.handleOnVaciarCartito}
              textoGenericoMembresia={textoGenericoMembresia}
            />}
          {/* CALENDARIO */}
          {this.props.openCalendario &&
            <CalendarioContainer
              usuario={this.props.usuario}
              instalacion={this.props.instalacion}
              handleOnClose={this.props.handleOnCloseCalendario}
              open={this.props.openCalendario}
            />
          }

          {this.props.repetirPedido &&
            <CalendarioContainer
              usuario={this.props.usuario}
              instalacion={this.props.instalacion}
              handleOnClose={this.props.handleOnCloseCalendario}
              open={this.props.openCalendario}
            />
          }

          {/* DRAWER NOTIFICACIONES */}
          {<DrawerNotificaciones
            usuario={this.props.usuario}
            instalacion={this.props.instalacion}
            pedido={this.props.pedido}
            handleOnClose={this.props.handleOnCloseNotificaciones}
            open={this.props.openNotificaciones}
            handleOnClickNotificaciones={this.props.handleOnClickNotificaciones}
            handleOnClickVerMas={this.props.handleOnClickVerMas}

          />}

          {/* WHATSAPP INSTALACION */}
          {this.props.instalacion && this.props.instalacion.datosContacto && this.props.instalacion.datosContacto.telefono &&
            <div
              className={`${classes.rootWhatsapp} 
              ${this.props.shouldShow === null ? '' : (this.props.shouldShow ? classes.show : classes.hide)} 
              ${this.props.pedido !== undefined && this.props.showResumenPedido === true ? 'buttonFlotanteContainerAux' : ''}
              buttonFlotanteContainer`
              }
            >
              <img src={require('../../images/whatsapp.png')} onClick={this.props.handleOnClickWhatsApp} />
            </div>}

          {/* FEEDBACK SMILE */}
          {token && <FeedbackButton token={token} />}

          {/* MODAL IDENTIFICATE */}
          <CustomModal
            open={this.props.openModalIdentificate}
            onClose={() => this.props.handleCerrarModalIdentificate(false)}
            title="Necesitamos saber quien sos"
            buttonNames={["IDENTIFICATE"]}
            fullWidth={true}
            buttonActions={
              [this.props.handleOnClickIdentificate]
            }
          >
            <div className='modalTextContent'>
            </div>
          </CustomModal>

          {/* LOADER */}
          {this.props.loading.show &&
            <div id='loader'>
              <div>
                <div className='loaderContainer'>
                  <CircularProgress />
                  <div className='mensaje'>{this.props.loading.message || 'Espere por favor'}</div>
                </div>
              </div>
            </div>}
        </div>
      </HashRouter>
    );
  }
}

Layout.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  handleDrawerOpen: PropTypes.func.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  loading: PropTypes.object.isRequired,
  instalacion: PropTypes.object.isRequired,
  header: PropTypes.object.isRequired,
  footer: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  preguntasFrecuentes: PropTypes.object,
  pedido: PropTypes.object,
  usuario: PropTypes.object,
  handleOnCerrarSesion: PropTypes.func.isRequired,
  handleOnClickLogo: PropTypes.func.isRequired,
  showResumenPedido: PropTypes.bool.isRequired,
  filterArticulos: PropTypes.string.isRequired,
  handleOnChangeFilter: PropTypes.func.isRequired,
  handleOnClearBusqueda: PropTypes.func.isRequired,
  handleOnClickIniciarSesion: PropTypes.func.isRequired,
  handleOnClickCheckout: PropTypes.func.isRequired,
  openResumenPedido: PropTypes.bool.isRequired,
  handleOnClickVerCarrito: PropTypes.func.isRequired,
  showBusqueda: PropTypes.bool.isRequired,
  handleAgregarQuitarUnidad: PropTypes.func.isRequired,

  handleOnClickBasesCondiciones: PropTypes.func.isRequired,
  handleOnVaciarCartito: PropTypes.func.isRequired,
  openCalendario: PropTypes.func.isRequired,
  handleOnClickOpenModalRubros: PropTypes.func.isRequired,
  openModalRubros: PropTypes.bool.isRequired,
  openModalIdentificate: PropTypes.bool.isRequired,
  openNotificaciones: PropTypes.bool.isRequired,
  handleOnCloseNotificaciones: PropTypes.func.isRequired,
  handleOnCloseCalendario: PropTypes.func.isRequired,
  handleOnClickOpenNotidicaciones: PropTypes.func.isRequired,
  handleOnClickOpenCalendario: PropTypes.func.isRequired,
  handleOnClickFavoritos: PropTypes.func.isRequired,
  handleOnClickNotificaciones: PropTypes.func.isRequired,
  handleOnClickVerMas: PropTypes.func.isRequired,
  handleOnClickIdentificate: PropTypes.func.isRequired,
  instalacionTexto: PropTypes.object.isRequired,
  fetchInstalacionTexto: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  instalacionTexto: instalacionTextoSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchInstalacionTexto: (instalacionId) => dispatch(sagaFetchInstalacionTexto(instalacionId)),
});

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Layout));